/**
 * @author simon
 * @Description: Root容器, 网站共用的可以放这里
 */

import './index.less';
import React, {useEffect} from 'react';
import { BrowserRouter } from 'react-router-dom';
import { renderRoutes } from '@/react-router-config-extend';
import routes from '@/routes';
import { stores, StoresProvider } from '@/store';
import 'lib-flexible';
import {initH5} from '@/utils/sa-sdk-javascript';
export const baseRoute = '/v2/';

function Application(props) {
  useEffect(() => {
    // 初始化
    initH5()
  })
  return (
    <StoresProvider value={stores}>
      <BrowserRouter basename={baseRoute}>{renderRoutes(routes)}</BrowserRouter>
    </StoresProvider>
  );
}

export default Application;
